import moment from "moment";

export default {
  report: null,
  reportRange: null,
  ...getControlPanelDefaultState()
};

export function getControlPanelDefaultState() {
  return {
    organization: null
  };
}

export function getDefaultReport() {
  return {
    monitored_complete_customers: 0,
    monitored_partial_custumers: 0,
    interactions_complete: 0,
    interactions_partial: 0,
    interactions_sms: 0
  };
}

export function getDefaultReportRange() {
  return {
    starts_at: moment().subtract(30, "days").unix(),
    ends_at: moment().unix()
  };
}
